import { CARS2ParsedResult } from "@api/assessments/assessment-schema-types";
import type { AssessmentLayoutConfig } from "@components/AssessmentFormRenderer/types/layoutTypes";

// Canonical form-variant strings. Must match the values produced by
// `_normalize_variant_string` in frontera-pipelines/python_pipelines/
// assessment_parsing/CARS_2/cars_2.py — FDM enrichment substring-matches
// "High Functioning" against this value to pick the HF severity table and
// HF description dictionary.
const CARS2_ST_TYPE = "CARS-2 (Childhood Autism Rating Scale, 2nd Edition-Standard Version)";
const CARS2_HF_TYPE = "CARS-2 (Childhood Autism Rating Scale, 2nd Edition-High Functioning Version)";

export const CARS_2_LAYOUT: AssessmentLayoutConfig = {
  parsedResultSchema: CARS2ParsedResult,
  sections: [
    {
      type: "single_select",
      key: "CARS-2 Type",
      label: "CARS-2 Type",
      editable: true,
      placeholder: "Select form variant...",
      options: [
        { label: "Standard", value: CARS2_ST_TYPE },
        { label: "High Functioning", value: CARS2_HF_TYPE },
      ],
    },
    {
      type: "text_field",
      key: "Assessment Date",
      label: "Assessment Date",
      editable: true,
      validation: { inputType: "date" },
    },
    {
      type: "score_table",
      label: "Category Scores",
      source: "Categories",
      columns: [
        { key: "Name", label: "Category", editable: false },
        {
          key: "Score",
          label: "Score",
          editable: true,
          validation: { min: 1, max: 4, step: 0.5, inputType: "number" },
        },
      ],
    },
    {
      type: "text_field",
      key: "Total Score",
      label: "Total Raw Score",
      editable: true,
      validation: { min: 15, max: 60, inputType: "number", step: 0.5 },
    },
  ],
};
